import cn from 'classnames';
import { IAdminUser } from 'types';
import { StyledAdminUsersListRow } from './styles';
import { AdminListCheckbox } from '../AdminListCheckbox';
import { AdminListRowCell } from '../AdminListRowCell';
import { ReactComponent as LinkIcon } from 'assets/icons/link-icon.svg';
import { ReactComponent as OkStatusIcon } from 'assets/icons/ok-vip-status-icon.svg';
import { ReactComponent as NotOkStatusIcon } from 'assets/icons/not-ok-vip-status-icon.svg';
import {apiAdminRoutes} from '../../../../lib';
import {store, useAppSelector} from '../../../../store/store';
import {setToken} from '../../../../store/slices/authSlice';
import {fetchUser} from '../../../../store/thunks/authThunk';
import {fetchUserSettings} from '../../../../store/thunks/userSettingThunks';

export interface IUsersListRowProps {
  children?: React.ReactNode;
  selected: boolean;
  onSelect: (id: IAdminUser['id'], selected: boolean) => void;
  user: IAdminUser;
}

export const userFieldMap: Record<string, (user: IUsersListRowProps['user'], token: string | null) => React.ReactNode> = {
  id: (user) => user.id,
  email: (user) => user.email,
  cost: (user) => user.cost,
  adjust: (user) => user.adjust,
  link: (user, token) => {
    const handleClick = async (e: React.MouseEvent<HTMLSpanElement>) => {
      e.preventDefault();
      const res = await fetch(apiAdminRoutes.apiAdminImpersonateUser(user.id), {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const data = await res.json();
      const newToken = data.token;

      store.dispatch(fetchUser(newToken));
      store.dispatch(setToken(newToken));
      store.dispatch(fetchUserSettings());

    };

    return (
        <span
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
        >
      <LinkIcon />
    </span>
    );
  },
  wallet: (user) => user.wallet,
  vip: (user) => (user.vip ? <OkStatusIcon /> : <NotOkStatusIcon />),
  averageDailyHashRate: (user) => user.averageDailyHashRate,
  averageWeeklyHashRate: (user) => user.averageWeeklyHashRate,
  createdAt: (user) => user.createdAt,
  updatedAt: (user) => user.updatedAt,
  comment: (user) => user.comment,
};

export const AdminUsersListRow = ({ user, selected, onSelect }: IUsersListRowProps) => {
  const { token } = useAppSelector((state) => state.auth);
  const selectRowHandler = () => {
    onSelect(user.id, !selected);
  };

  return (
    <StyledAdminUsersListRow>
      <div className="admin-list-cell-container select">
        <AdminListCheckbox checked={selected} onChange={selectRowHandler} />
      </div>
      {Object.entries(userFieldMap).map(([title, valueGetter]) => (
        <div key={title} className={cn('admin-list-cell-container', title.toLowerCase())}>
          <AdminListRowCell>{valueGetter(user, token)}</AdminListRowCell>
        </div>
      ))}
    </StyledAdminUsersListRow>
  );
};
